export function getMappings(state, categoryId) {
  const {mappings} = state.settings
  if (!mappings) return null

  return mappings[categoryId]
}

export function getChannelMappings(state, channelGroupId, channelId) {
  const {channelMappings} = state.settings
  if (!channelMappings) return null

  const mappingsForChannel = channelMappings[`${channelGroupId}/${channelId}`]
  if (mappingsForChannel && mappingsForChannel.length) {
    return mappingsForChannel
  }

  return null
}

export function getUnmappedChannels(state) {
  const {unmappedChannels} = state.settings
  if (!unmappedChannels) return null

  return unmappedChannels
}

export function getUnmappedUrls(state) {
  const {unmappedUrls} = state.settings
  if (!unmappedUrls) return null

  return unmappedUrls
}

export function getUrlMappings(state) {
  const {urlMappings} = state.settings
  if (!urlMappings) return null

  return urlMappings
}

export function getUnmappedReferrers(state) {
  const {unmappedReferrers} = state.settings
  if (!unmappedReferrers) return null

  return unmappedReferrers
}

export function getReferrerMappings(state) {
  const {referrerMappings} = state.settings
  if (!referrerMappings) return null

  return referrerMappings
}

export function getUnmappedUtms(state) {
  const {unmappedUtms} = state.settings
  if (!unmappedUtms) return null

  return unmappedUtms
}

export function getUtmMappings(state) {
  const {utmMappings} = state.settings
  if (!utmMappings) return null

  return utmMappings
}

export function getUnmappeImpressions(state) {
  const {unmappedImpressions} = state.settings
  if (!unmappedImpressions) return null

  return unmappedImpressions
}

export function getMappableChannels(state) {
  const {mappableChannels} = state.settings
  if (!mappableChannels) return null

  return mappableChannels.reduce((acc, item) => {
    const group = item.key
    const channels = item.channels.map(item => `${group}/${item.key}`)

    return {
      groups: acc.groups.concat(group),
      channels: acc.channels.concat(channels)
    }
  }, {groups: [], channels: []})
}

export function getMapUnmappedChannelSaving(state) {
  const {isMapUnmappedChannelSaving} = state.settings
  return isMapUnmappedChannelSaving
}


// WEBPACK FOOTER //
// ./client/redux/modules/settings/selectors.js